<bluesky-post class="position-relative">
  <div class="text">
    {props.post.text()}
  </div>

  <div if={props.post.hasImages()} class="images">
    <div
      each={image in props.post.images()}
      class="ratio ratio-1x1 mb-3"
    >
      <img
        src={image['thumb']}
        class="rounded"
      />
    </div>
  </div>

  <div if={props.post.hasVideo()} class="video">
    <video class="rounded" loop />
  </div>

  <a
    if={props.post.isExternalLink()}
    href={props.post.externalLink()['uri']}
    class="external"
  >
    <strong>{props.post.externalLink()['title']}</strong>
    <img src={props.post.externalLink()['thumb']} />
    <div class="description">
      {props.post.externalLink()['description']}
    </div>
  </a>

  <div class="time-stamp text-end">
    {props.post.createdAtHuman()}
  </div>

  <a href={props.post.url()} target="_blank" class="stretched-link"></a>

  <hr size="3" />

  <script>
    export default class {
      onMounted() {
        this.setupVideo()
      }

      setupVideo() {
        console.log(this.props)
        window.posts = window.posts || []
        window.posts.push(this.props.post)

        if (!this.props.post.hasVideo()) return

        const video = this.props.post.video()
        const element = this.root.querySelector('video')

        console.log(video, element)

        if (Hls.isSupported()) {
          var hls = new Hls()
          hls.loadSource(video.playlist)
          hls.attachMedia(element)
          hls.on(Hls.Events.MANIFEST_PARSED, () => {
            element.play()
          });
        } else if (videoRef.canPlayType('application/vnd.apple.mpegurl')) {
          // Fallback for native HLS support in Safari
          element.src = video.playlist
          element.addEventListener('loadedmetadata', () => {
            element.play()
          })
        }
      }
    }
  </script>
</bluesky-post>
